import { patchRequest } from "../httpMethods";




export const patchLmsBoards = (id) =>
    patchRequest(`lms/boards/${id}`);

export const patchLmsGrades = (id) =>
    patchRequest(`lms/grades/${id}`);

export const patchLmsTag = (payload ,id) =>
    patchRequest(`tags/${id}`, payload);

export const patchSubjectTag = (payload ,id) =>
    patchRequest(`subject/${id}`, payload);

export const patchChapter = (payload ,id) =>
    patchRequest(`chapters/${id}`, payload);

export const patchTopic = (payload ,id) =>
    patchRequest(`topics/${id}`, payload);

export const patchLmsPublications = (id) =>
    patchRequest(`lms/publications/${id}`);


export const patchLmsLanguage = (id) =>
    patchRequest(`lms/languages/${id}`);

export const patchAssignTicket = (payload, id) =>
    patchRequest(`tickets/${id}/assign`, payload);


export const patchDocNameStatus = (id, payload) =>
    patchRequest(`v1/document/${id}/status`, payload);

export const patchFinalizeAiLmsVersion = (versionId) =>
    patchRequest(`v1/ai-lms/finalize/${versionId}`);